import { render } from "./GlobalLocations.vue?vue&type=template&id=6bd72e52"
import script from "./GlobalLocations.vue?vue&type=script&lang=js"
export * from "./GlobalLocations.vue?vue&type=script&lang=js"

import "./GlobalLocations.vue?vue&type=style&index=0&id=6bd72e52&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__